// extracted by mini-css-extract-plugin
module.exports = {"companies":"CompanyList_companies__2IB5e","errorun":"CompanyList_errorun__1bO7o","none":"CompanyList_none__2yBFD","errormess":"CompanyList_errormess__1ZbEz"};